'use strict';

/**
 * Collection for conversations
 *
 * @category   Collection
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ConversationModel = require('../models/conversation');

var ConversationsCollection = Collection.extend({
    api: '/community/conversations',

    name: 'community:conversations',

    model: ConversationModel,

    initialize: function() {
        this.applyPatchExtension();

        this.on('destroy', function(conversation) {
            App.radio('community').trigger('conversation:destroy', conversation);
        });

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    /**
     * Override default comparator to order by id, when default comparison is equal
     * @param {Backbone.Model} a Model a
     * @param {Backbone.Model} b Model b
     * @returns {integer}
     */
    comparator: function(a, b) {
        var compare = Collection.prototype.comparator.call(this, a, b);

        if (compare === 0) {
            return parseInt(a.get('id')) < parseInt(b.get('id')) ? -1 : 1;
        } else {
            return compare;
        }
    },

    getUnreadPostsCount: function() {
        var allUndreadPostsCounts = this.pluck('unreadPosts');

        return _.reduce(allUndreadPostsCounts, function(memo, count){ return memo + count; });
    },
});

module.exports = ConversationsCollection;